import * as React from 'react';
const SvgFilter = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path fill="#fff" fillOpacity={0.01} d="M0 0h24v24H0z" />
    <path
      fill="currentColor"
      d="M19.95 16.77a.5.5 0 0 0-.22-.22.5.5 0 0 0-.18-.05h-9.26C9.9 15.62 9.03 15 8 15s-1.9.62-2.29 1.5H4.8c-.28 0-.42 0-.53.05-.09.05-.17.12-.22.22-.05.11-.05.25-.05.53v.4c0 .28 0 .42.05.53.05.09.12.17.22.22.06.03.14.05.25.05H5.7c.39.88 1.26 1.5 2.29 1.5s1.9-.62 2.29-1.5h8.91c.28 0 .42 0 .53-.05.09-.05.17-.12.22-.22.03-.06.04-.12.05-.22v-.99c0-.11-.02-.19-.05-.25zM7 17.5c0-.55.45-1 1-1s1 .45 1 1-.45 1-1 1-1-.45-1-1M20 5.02c0-.11-.02-.19-.05-.25a.5.5 0 0 0-.22-.22.5.5 0 0 0-.18-.05h-9.26C9.9 3.62 9.03 3 8 3s-1.9.62-2.29 1.5H4.8c-.28 0-.42 0-.53.05-.09.05-.17.12-.22.22C4 4.88 4 5.02 4 5.3v.4c0 .28 0 .42.05.53.05.09.12.17.22.22.06.03.14.05.25.05H5.7C6.09 7.38 6.96 8 7.99 8s1.9-.62 2.29-1.5h8.91c.28 0 .42 0 .53-.05.09-.05.17-.12.22-.22.03-.06.04-.12.05-.22v-.99zM7 5.5c0-.55.45-1 1-1s1 .45 1 1-.45 1-1 1-1-.45-1-1M19.73 10.55a.55.55 0 0 0-.25-.05H18.3c-.39-.88-1.26-1.5-2.29-1.5s-1.9.62-2.29 1.5H4.8c-.28 0-.42 0-.53.05-.09.05-.17.12-.22.22-.03.06-.04.12-.05.22v.99c0 .11.02.19.05.25.05.09.12.17.22.22.05.03.11.04.18.05h9.25c.39.88 1.26 1.5 2.29 1.5s1.9-.62 2.29-1.5h.91c.28 0 .42 0 .53-.05.09-.05.17-.12.22-.22.05-.11.05-.25.05-.53v-.4c0-.28 0-.42-.05-.53a.5.5 0 0 0-.22-.22zM15 11.5c0-.55.45-1 1-1s1 .45 1 1-.45 1-1 1-1-.45-1-1"
    />
  </svg>
);
export default SvgFilter;
